import React from 'react'
import { Container } from 'reactstrap'
const PageContainer = (props) => {
    return (
        <div className="wrapper pt-3 pb-3">
            <Container>
                {props.children}
            </Container>
        </div>
    )
}
export default PageContainer